<template>
  <div class="integrity-enterprise">
      <!-- 表格展示区 -->
    <el-table :data="integrityEnterpriseList" border style="width: 100%">
      <el-table-column
        type="index"
        align="center"
        width="50"
      >
      </el-table-column>
      <el-table-column
        prop="enterpriseName"
        align="center"
        label="企业名称"
        width="300"
      >
      </el-table-column>
      <el-table-column
        prop="enterpriseCode"
        align="center"
        label="企业统一社会信用代码"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="areaCode"
        align="center"
        label="诚信企业承诺书模板"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="mainPerson"
        align="center"
        label="企业联系人"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="telephone"
        align="center"
        label="联系人号码"
        width="200"
      >
      </el-table-column>
      <el-table-column label="操作"  align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="updateHandle(scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改弹窗 -->
    <integrity-add-update 
        ref="integrityEnterpriseUpdate"
        @integrityEnterpriseUpdate='getIntegrityEnterpriseList'
    >
    </integrity-add-update>
    <!-- 分页展示 -->
    <el-pagination
        background
        layout="total,prev, pager, next"
        :total="totalCount"
        @current-change="pageChange"
    >
</el-pagination>
  </div>
</template>

<script>
import IntegrityAddUpdate from './integrity-enterprise-add-or-update.vue'
export default {
    data() {
        return {
            integrityEnterpriseList:[],//诚信企业列表
            // 获取诚信企业列表参数
            demandQuery: {
                limit: 10,
                page: 1,
            }, 
            totalCount: 0,// 诚信企业列表总数
            loading: false,//是否处于加载中
        }
    },
    mounted(){
        this.getIntegrityEnterpriseList()
    },
    methods: {
        //获取诚信企业列表
        getIntegrityEnterpriseList(){
            this.loading = true
            this.$ajaxPost('/enterprise/list/open',this.demandQuery).then(({data}) => {
                console.log('1234',data)
                if(data.code === 0){
                    this.integrityEnterpriseList = data.data.list.filter((item) => {
                        return item.businessLicense!=null && item.commitment!=null
                    })
                    this.totalCount = this.integrityEnterpriseList.length
                    this.loading = false;
                }
            })
        },
        //修改按钮的回调
        updateHandle(id){
            this.$nextTick(() => {
                this.$refs.integrityEnterpriseUpdate.init(id)
            })
        },
                //删除按钮的回调
        deleteHandle(id){
            this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning", 
            }).then(() => {
                    this.$ajaxPost("/enterprise/delete", [id]).then(
                        ({ data }) => {
                            if (data.code === 0) {
                                this.getIntegrityEnterpriseList();
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                            }
                        }
                    );
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                }); 
        },
        //分页展示
        pageChange(currPage) {
            this.demandQuery.page = Number(currPage);
            this.getIntegrityEnterpriseList();
        },
    },
    components:{
        IntegrityAddUpdate
    }
};
</script>

<style>
</style>